import { nanoid } from 'nanoid'
import _, { cloneDeep } from 'lodash-es'

export const state = () => ({
  pageData: {
    sections: [],
    customStyle: '',
    customScript: ''
  },
  pageInfo: {
    img: '',
    name: '',
    seo: {
      seoDescription: '',
      seoKeywords: '',
      seoTitle: ''
    }
  }
})

// getters派生/计算属性
export const getters = {
  getSection: (state) => (id) => {
    return state.pageData.sections.find(sect => sect.id == id);
  },
}

// mutations只能同步操作
export const mutations = {
  addSection(state, { section, index }) {
    if(index == null || Number.isNaN(index)) {
      index = 0;
    }
    state.pageData.sections.splice(index, 0, section);
    console.log(state.pageData)
  },
  deleteSection(state, { index } ) {
    state.pageData.sections.splice(index, 1);
  },
  setPageData(state, { pageData }) {
    state.pageData = pageData;
  },
  setPageInfo(state, { pageInfo }) {
    state.pageInfo = pageInfo;
  },
  setSections(state, { sections }) {
    state.pageData.sections = sections;
  },
  setSection(state, { section }) {
    const index = state.pageData.sections.findIndex(sect => sect.id === section.id);
    if(index >= 0) {
      state.pageData.sections.splice(index, 1, section);
    }
  },
  moveSectionUp(state, { index }) {
    if(index == 0) {
      return;
    }
    moveSection(state.pageData.sections, index, index-1)
  },
  moveSectionDown(state, { index }) {
    if(index == state.pageData.sections.length - 1) {
      return;
    }
    moveSection(state.pageData.sections, index, index+1)
  },

  setCustomStyle(state, { code }) {
    state.pageData.customStyle = code;
  },
  setCustomScript(state, { code }) {
    state.pageData.customScript = code;
  },
}

function moveSection(sections, from, to) {
  const section = sections.splice(from, 1)[0];
  sections.splice(to, 0, section);
}

// actions主要是异步操作
export const actions = {
  addSection({ state, rootState, commit}, { section: sect, index }) {
    const section = { 
      id: nanoid(),
      ...sect
    };

    commit('addSection', { section, index });
    commit('editor/hideAddSection', null, { root: true });

    return section.id;
  },
  duplicateSection({state, rootState, commit, getters }, { index }) {
    const sect = state.pageData.sections[index];
    const section = { 
      ...sect,
      id: nanoid(), // 生成新ID
    };

    commit('addSection', { section, index: index + 1 });
    return section.id;
  },
  async loadPageData({ state, commit }, { id }) {
    let pageInfo = await this.$axios.$get('/channel/channelInfo.do?channelId=' + id);
    // let pageInfo = JSON.parse(window.localStorage.getItem('pageInfo' + id));
    // if(!pageInfo) {
    //   pageInfo = {
    //     img: '',
    //     name: '',
    //     seo: {
    //       seoDescription: '',
    //       seoKeywords: '',
    //       seoTitle: ''
    //     }
    //   }
    // }
    let pageData = { sections: [], customStyle: '', customScript: ''};
    if(pageInfo && !_.isEmpty(pageInfo.channelData)) {
      pageData = JSON.parse(pageInfo.channelData);
    }
    console.log(pageInfo)
    commit('setPageData', { pageData });
    commit('setPageInfo', { pageInfo });
  },
  async savePageData({ state }, { id }) {
    const token = '';
    const result = await this.$axios.$post(`/channel/setChannelData.do?channelId=${id}&token=${token}`, state.pageData);
    return result.code;
    // window.localStorage.setItem('pageInfo' + id,  JSON.stringify({ channelData: JSON.stringify(state.pageData) }));
    // alert('页面保存成功！')
  }
}